import React, { useRef, useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Avatar,
  Menu,
  MenuItem,
  ListItemIcon,
  Box,
  Divider,
  Badge,
} from "@mui/material";

import NotificationsIcon from "@mui/icons-material/Notifications";
import FileUploadIcon from "@mui/icons-material/FileUpload";

import SettingsIcon from "@mui/icons-material/Settings";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import ClearAllIcon from "@mui/icons-material/ClearAll";

import { useNavigate } from "react-router-dom";

export default function AdminHeader() {
  const navigate = useNavigate();

  /* ---------------- AVATAR STATE ---------------- */
  const [profileImage, setProfileImage] = useState(
    localStorage.getItem("adminProfileImage") || ""
  );

  useEffect(() => {
    if (profileImage) {
      localStorage.setItem("adminProfileImage", profileImage);
    }
  }, [profileImage]);

  /* ---------------- PROFILE MENU ---------------- */
  const [anchorEl, setAnchorEl] = useState(null);
  const openProfileMenu = Boolean(anchorEl);

  const fileInputRef = useRef(null);


  const handleProfileClick = (e) => setAnchorEl(e.currentTarget);
  const handleProfileClose = () => setAnchorEl(null);

  /* ---------------- NOTIFICATIONS ---------------- */
  const [notifAnchor, setNotifAnchor] = useState(null);
  const openNotif = Boolean(notifAnchor);

  const [notifications, setNotifications] = useState([
    { id: 1, text: "New leave request pending" },
    { id: 2, text: "Payroll approval required" },
    { id: 3, text: "New employee onboarded" },
  ]);

  const handleNotifClick = (e) => {
    setNotifAnchor(e.currentTarget);
  };

  const handleNotifClose = () => setNotifAnchor(null);

  const clearNotifications = () => {
    setNotifications([]);
    handleNotifClose();
  };

  /* ---------------- IMAGE HANDLERS ---------------- */
  const handleImageChange = (file) => {
    if (!file) return;
    const imageURL = URL.createObjectURL(file);
    setProfileImage(imageURL);
  };

  const handleMenuAction = (action, path) => {
    handleProfileClose();

    if (action === "upload") {
      fileInputRef.current?.click();
    }

    if (action === "settings") {
      navigate(path);
    }

    if (action === "signout") {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/", { replace: true });
    }
  };

  const profileMenuItems = [
    { name: "Upload Image", action: "upload", icon: <FileUploadIcon /> },
    {
      name: "Settings",
      action: "settings",
      path: "/admin/system-settings",
      icon: <SettingsIcon />,
    },
    { name: "Sign Out", action: "signout", icon: <ExitToAppIcon /> },
  ];

  return (
    <>
      {/* FILE INPUT */}
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        hidden
        onChange={(e) => handleImageChange(e.target.files[0])}
      />

      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "#ffffff",
          color: "#111827",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          zIndex: 2000,
        }}
      >
        <Toolbar>
          <Typography sx={{ flexGrow: 1, fontWeight: 700 }}>
            Admin Portal
          </Typography>

          {/* NOTIFICATIONS */}
          <IconButton onClick={handleNotifClick} sx={{ color: "#374151" }}>
            <Badge
              color="error"
              variant="dot"
              invisible={notifications.length === 0}
            >
              <NotificationsIcon />
            </Badge>
          </IconButton>

          {/* NOTIFICATION MENU */}
          <Menu
            anchorEl={notifAnchor}
            open={openNotif}
            onClose={handleNotifClose}
            PaperProps={{ sx: { width: 280, mt: 1.5 } }}
          >
            <Box px={2} py={1} fontWeight={600}>
              Notifications
            </Box>
            <Divider />

            {notifications.length === 0 ? (
              <MenuItem disabled>No notifications</MenuItem>
            ) : (
              notifications.map((n) => (
                <MenuItem key={n.id}>{n.text}</MenuItem>
              ))
            )}

            {notifications.length > 0 && (
              <>
                <Divider />
                <MenuItem onClick={clearNotifications}>
                  <ListItemIcon>
                    <ClearAllIcon />
                  </ListItemIcon>
                  Clear All
                </MenuItem>
              </>
            )}
          </Menu>

          {/* AVATAR */}
          <Avatar
            src={profileImage || undefined}
            sx={{
              ml: 2,
              cursor: "pointer",
              bgcolor: profileImage ? "transparent" : "#2563EB",
            }}
            onClick={handleProfileClick}
          >
            {!profileImage && "AD"}
          </Avatar>

          {/* PROFILE MENU */}
          <Menu
            anchorEl={anchorEl}
            open={openProfileMenu}
            onClose={handleProfileClose}
            PaperProps={{
              sx: { mt: 1.5, minWidth: 200, borderRadius: 2 },
            }}
          >
            {profileMenuItems.map((item) => (
              <MenuItem
                key={item.name}
                onClick={() => handleMenuAction(item.action, item.path)}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                {item.name}
              </MenuItem>
            ))}
          </Menu>
        </Toolbar>
      </AppBar>
    </>
  );
}
